const productSlider = $(".product-swiper");
const productImgCta = $(".product-image-cta");
const productSliderThumbnails = $(".thumbnails-swiper");
const productSliderModalId = "#productSliderModal";
const productSliderInModal = $("#productSliderInModal");
let productSliderModal = null;

const clickSlide = function (ev) {
  ev.preventDefault();
  ev.stopPropagation();
  openModal();
};

const openModal = () => {
  if (productSliderModal === null) {
    productSliderModal = new bootstrap.Modal(productSliderModalId);
  }
  
  productSliderInModal.find(".img-box").show();
  productSliderModal.show();
};

const bind = function () {
  if (productSlider.length === 1 && productSliderThumbnails.length === 1) {
    productSlider.on("click", clickSlide);
  }

  if (productImgCta.length === 1 && productSliderThumbnails.length === 1) {
    productImgCta.on("click", clickSlide);
  }

  $('.product-swiper .swiper-button-next, .product-swiper .swiper-button-prev').on('click', (e) => {
    e.stopPropagation();
  });
};

export { bind };
